import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'

// import { apiGetRoomGoldInfo, apiExtractGold } from 'src/helper/room'
import lang from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'

@inject('store')
@observer
export default class RoomRewards extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    roomInfo: {
      trophy: 0,
      proportion: 0,
      extractableGold: 0,
      todayReward: 0,
      thisMonthReward: 0,
      lastMonthReward: 0
    },
    lang: lang.en,
    loading: false,
    isShowTips: false,
    httpMsg:"",
    language:'en',
  }
  async componentDidMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, lang)
    if (language == 'en') {
      setDocumentTitle('Recharge activity')
    }else if (language == 'tr') {
      setDocumentTitle('Çekim Etkinliği')
    }else{
      setDocumentTitle('نشاط إعادة  الشحن')
    }
    this.setState({language,lang: setlang(language, lang),})
  }



  render() {
    let {  lang, language } = this.state
    return (
      <div className={`new-change-emtyp ${this.state.language == 'ar' ? 'arlang' : ''}`}>
        <div className='rmeisehjh'>
            <img className='imgname' src='/img/new_page_search_result.png'></img>
         </div>
         <div className='tnenw'>{lang.setTest}</div>
        {/* 下架提示 */}
        {/* <div
          style={{ display: `${this.state.isShowTips ? "flex" : "none"}` }}
          className="down-tips">
          <div
            className="content"
            onClick={() => {
              this.setState({
                isShowTips: false
              })
            }}
          >
            {this.state.lang.tips}
          </div>
        </div> */}
{/* 
        <div
          style={{ filter: `${this.state.isShowTips ? "blur(10px)" : ""}` }}
          className="room-rewards--title">
          <h2>
            {this.state.lang.current}:&nbsp; {score(this.state.roomInfo.trophy)} &nbsp; ({this.state.lang.ratio}:
            {this.state.roomInfo.proportion}%)
          </h2>
          <div className="room-rewards--number">
            <div className="number-content">
              <img src="/img/app/room/gold.jpg" alt="" />
              {this.state.roomInfo.extractableGold}
            </div>
            <div onClick={this.handleExtractGold.bind(this)} className="number-button">
              {this.state.lang.get}
            </div>
          </div>
          <div className="room-rewards--static">
            <div>
              <p style={{fontSize:`${this.state.language == 'tr'?'0.22rem':'0.24rem'}`}}>{this.state.lang.today}</p>
              <p>{this.state.roomInfo.todayReward}</p>
            </div>
            <div className="is-line">
              <p>{this.state.lang.month}</p>
              <p>{this.state.roomInfo.thisMonthReward}</p>
            </div>
            <div className="is-line">
              <p>{this.state.lang.lastMonth}</p>
              <p>{this.state.roomInfo.lastMonthReward}</p>
            </div>
            <div >
              <p>{this.state.lang.onMicTime}</p>
              <p>{this.state.roomInfo.onMicMinute}</p>
            </div>
          </div>
        </div>
        <div
          style={{ filter: `${this.state.isShowTips ? "blur(10px)" : ""}` }}
          className="room-rewards--rules">
          <div className="rules-content">
            <h2 className="rules-content--title">{this.state.lang.rule}</h2>
            <ul>
              <li dangerouslySetInnerHTML={{ __html:this.state.lang.rulesConten}}></li>
            </ul>
          </div>
          <div className="rules-table">
            <table>
              <thead>
                <tr>
                  <td>{this.state.lang.roomCup}</td>
                  <td>{this.state.lang.medal}</td>
                  <td style={{borderLeft:'0.01rem solid #ffffff8c'}}>{this.state.lang.ratioText}</td>
                  <td style={{borderLeft:'0.01rem solid #ffffff8c'}}>{this.state.lang.onMicTime}</td>
                </tr>
              </thead>

              {rewardsRules.map((item, index) => {
                return (
                  <tbody key={index}>
                    <tr>
                      <td>{item.gold}</td>
                      {index <1 &&
                        <td>{item.medal}</td>
                      }
                      {index > 0 &&
                        <td><img src={item.medal} /></td>
                      }
                      <td>{item.ratio}</td>
                      <td>{item.time}</td>
                    </tr>
                  </tbody>
                )
              })}

            </table>
          </div>
        </div>

        {this.state.loading && (
          <div className="loading">
            <p>{this.state.httpMsg || this.state.lang.success}</p>
          </div>
        )} */}

      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/newChangeEmtyp/index.js